import React from 'react';
import { withoutId } from '../../utils/data.js';
import { InputNumber, Table, Button } from 'antd';
import { PercentageOutlined } from '@ant-design/icons';

function PercentageSplitSubmenu(props) {
  let func = props.row.func;
  let isCompound = false;
  if (props.compoundIndex !== undefined && props.compoundIndex !== null) {
    func = func.functions[props.compoundIndex];
    isCompound = true;
  }
  
  const dataSource = [
    { key: '1', sales: func.sales, pm: func.pm, dir: func.dir },
  ];

  const columns = [
    {
      title: 'Sales',
      dataIndex: 'sales',
      key: 'sales',
      width: 100,
      align: 'right',
      render: (value) => {
        return (<InputNumber
          key={'sales-input'}
          addonAfter={<PercentageOutlined />}
          max={100}
          min={0}          
          defaultValue={value.toFixed(0)}
          onChange={(value) => { props.onPercentageChange('sales', value); }} />
        );
      }
    },
    {
      title: 'PM',
      dataIndex: 'pm',
      key: 'pm',
      width: 100,
      align: 'right',
      render: (value) => {
        return (<InputNumber
          key={'sales-input'}
          addonAfter={<PercentageOutlined />}
          max={100}
          min={0}          
          defaultValue={value.toFixed(0)}
          onChange={(value) => { props.onPercentageChange('pm', value); }} />
        );
      }
    },
    {
      title: 'Dir',
      dataIndex: 'dir',
      key: 'dir',
      width: 100,
      align: 'right',
      render: (value) => {
        return (<InputNumber
          key={'sales-input'}
          addonAfter={<PercentageOutlined />}
          max={100}
          min={0}          
          defaultValue={value.toFixed(0)}
          onChange={(value) => { props.onPercentageChange('dir', value); }} />
        );
      }
    },
  ];

  function back() {
    props.setMenuVisible(true);
    props.setPercentageVisible(false);
  }

  function ok() {
    props.setOpen(false);
  }

  return (
    <div>
      <Table dataSource={dataSource}
        columns={columns}
        pagination={false} />
      <Button type="default"
        style={{
          marginTop: '20px',
          float: 'right',
          marginRight: '10px'
        }}
        onClick={back}>Back</Button>
      <Button type="primary"
        style={{
          marginTop: '20px',
          float: 'right',
          marginRight: '10px'
        }}
        onClick={ok}>OK</Button>
    </div>
  );
}

export default PercentageSplitSubmenu;
